// ABOUTME: Renders the inline settings form of an onboarding step by mapping each field kind
// ABOUTME: onto the existing Setting components, so a step can be configured without leaving the page.

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import BoolSetting from "../../../../../components/global/Settings/BoolSetting";
import DropdownSetting from "../../../../../components/global/Settings/DropdownSetting";
import NumberSetting from "../../../../../components/global/Settings/NumberSetting";
import StringSetting from "../../../../../components/global/Settings/StringSetting";
import { useGetEnumsQuery } from "../../../../../newapi/global/generalApiSlice";

// Option values whose translation key differs from the value itself.
const OPTION_LABELS = {
    "false": "no",
    "true": "yes",
    timer: "echeck_timer",
    warehouselocation_type: "warehouse_location_type",
};

const RELATION_ID = -1;

const StepFields = ({ step, onChange }) => {
    const { t } = useTranslation();
    const { data: enums } = useGetEnumsQuery();

    const toOptions = (values) => (values ?? []).map((value) => ({
        id: value,
        value,
        name: t(OPTION_LABELS[value] ?? value),
    }));

    const optionsFor = (field) => {
        if (field.options) {
            return toOptions(field.options);
        }
        return toOptions(enums?.[field.enumName]);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {step.fields.map((field) => {
                const isRelation = field.scope === "relationsetting";
                const settings = isRelation ? step.relationSettings : step.settings;
                const relationProps = isRelation ? { relationId: RELATION_ID } : {};

                switch (field.kind) {
                    case "bool":
                        return (
                            <BoolSetting
                                key={field.key}
                                manualSave
                                onChange={onChange}
                                settings={settings}
                                skey={field.key}
                                {...relationProps}
                            />
                        );
                    case "number":
                        return (
                            <NumberSetting
                                key={field.key}
                                manualSave
                                hideSaveButton
                                onChange={onChange}
                                maxWidth={240}
                                settings={settings}
                                skey={field.key}
                                {...relationProps}
                            />
                        );
                    case "string":
                        return (
                            <StringSetting
                                key={field.key}
                                manualSave
                                onChange={onChange}
                                maxWidth={400}
                                settings={settings}
                                skey={field.key}
                                {...relationProps}
                            />
                        );
                    case "dropdown":
                        return (
                            <DropdownSetting
                                key={field.key}
                                manualSave
                                onChange={onChange}
                                settings={settings}
                                objects={optionsFor(field)}
                                noselection={"choose_option"}
                                variant={"default"}
                                skey={field.key}
                                {...relationProps}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </Box>
    );
};

export default StepFields;
